import * as React from 'react';
import { IButtonProps } from './Button';

interface IButtonGroupContext extends Pick<IButtonProps, 'size' | 'variant' | 'mode'> {
  isGroup?: boolean;
}

export const ButtonGroupContext = React.createContext<IButtonGroupContext | undefined>(undefined);
